import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../store/base.graphql";
import {profileFields} from "../login/login.graphql";


export const UPDATE_USER_PROFILE = gql`
  mutation UpdateMyProfile($input: InstitutionAdminInputObject!) {
    updateMyProfile(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${profileFields}
      }
    }
  }
`


export const GET_CITIZEN_PROFILE_UPGRADE_TO_SERVANT_CHECK = gql`
  query GetCitizenProfile {
  getCitizenProfile {
    ${baseResponseGraphqlField}
    data {
      id
      citizenServantAttempt
      citizenServant
      citizenType
      citizenUserProfile {
        profileType
      }
      }
  }
}`


export const GET_CITIZEN_PROFILE = gql`
  query GetCitizenProfile($profileUniqueId: String) {
    getCitizenProfile(profileUniqueId: $profileUniqueId) {
      response {
        id
        status
        code
        message
      }
      data {
        id
        citizenUniqueId
        citizenUserProfile {
          id
          profileUniqueId
          userFirstName
          userLastName
          userEmail
          profilePhone
          profileTitle
          profilePhoto
          profileIsActive
          profileIsDeactivated
          profileType
          userDesignation {
            id
            designationUniqueId
            designationShortForm
            designationName
          }
          role {
            id
            roleUniqueId
            roleName
            roleIsAdmin
            roleIsSystemDefault
            roleDescription
            rolePermissions {
              id
              permissionUniqueId
              permissionName
              permissionCode
            }
          }
        }
        citizenNidaNumber
        citizenPassport
        citizenType
        citizenServantAttempt
        citizenServant
      }
    }
  }`

export const CITIZEN_UPGRADE_TO_SERVANT_MUTATION = gql`
  mutation CitizenUpgradeToServantMutation($isServant: Boolean!) {
    citizenUpgradeToServantMutation(isServant: $isServant) {
      response {
        id
        status
        code
        message
      }
    }
  }`
